export enum InterviewStageEnum {
  Welcome = 'welcome',
  Permissions = 'permissions',
  Call = 'call',
  Results = 'results'
}
